// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"3edea981669535ceb72e","691":"09284250d5ee85a8ee6d"}[chunkId] + ".js";
};